import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@service-features/auth.service';
import { ArcaElectronicBillingService } from '@service-features/arca-electronic-billing.service';
import { HeaderComponent } from '@shared-components/header/header.component';
import { SpinnerComponent } from '@shared-components/spinner/spinner.component';
import { AppUpdateService } from '@shared-services/app-update.service';
import { environment } from 'environments/environment';
import { SessionRecordingService } from './core/observability/session-recording/session-recording.service';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, HeaderComponent, RouterOutlet, SpinnerComponent],
})
export class AppComponent {
  constructor(
    private titleService: Title,
    private authService: AuthService,
    private readonly router: Router,
    appUpdateService: AppUpdateService,
    arcaElectronicBillingService: ArcaElectronicBillingService,
    sessionRecordingService: SessionRecordingService,
  ) {
    appUpdateService.start();
    sessionRecordingService.start();
    const titlePrefix = environment.envLabel
      ? `${environment.envLabel} - `
      : '';
    this.titleService.setTitle(`${titlePrefix}GarageDigital`);
    if (this.authService.isLoggedUser) {
      arcaElectronicBillingService.loadElectronicBillingIntegrationStatus();
    }
  }

  get isAuthenticated(): boolean {
    return this.authService.isLoggedUser;
  }

  get isPublicLayout(): boolean {
    const path = this.router.url.split(/[?#]/, 1)[0];
    return path.startsWith('/vehicle-passport/');
  }

  get showAuthenticatedHeader(): boolean {
    return this.isAuthenticated && !this.isPublicLayout;
  }
}
